export const redirectTypes = {

}

export const redirectModes = {
    ROUTE_NAME: "ROUTE_NAME",
    REDIRECT_URL: "REDIRECT_URL",
    SHOW_ALERT: "SHOW_ALERT"
};